import Transformer from "../../transformer";

class SupplyInStock extends Transformer {
  static fetch(supply) {
    return {
      id: supply.id,
      name: supply.name || "sin nombre",
      quantity: Number(supply.in_stock),
      supplyCode: supply.code,
      unitMeasurement: supply.unit_measurement,
      responsibleUser: supply.responsible_user,
    };
  }
}

class SupplyStockWarehouse extends Transformer {
  static fetch({
    id,
    name = "sin nombre",
    in_stock,
    code,
    unit_measurement: unitMeasurement,
    responsible_user: responsibleUser,
  }) {
    return {
      id,
      name,
      quantity: Number(in_stock),
      supplyCode: code,
      unitMeasurement,
      responsibleUser,
    };
  }
}

class SeparatedSupply extends Transformer {
  static fetch(supply) {
    return {
      id: supply.id,
      name: supply.supply.supply_name || "sin nombre",
      price: Number(supply.unit_price),
      quantity: Number(supply.quantity),
      sinister: supply.snumber,
      affected: supply.affected,
      warehouseMovement: supply.warehouse_movement,
    };
  }
}

export default class WarehouseTransformer extends Transformer {
  static fetch(warehouse) {
    return {
      // aqui deberían traer el mismo nombre en los 3 primero pero por ahora una ternaria. checar lo hizo sandy
      id: warehouse.iwarehouse ? warehouse.iwarehouse : warehouse.id,
      name: warehouse.iwarehouse_name
        ? warehouse.iwarehouse_name
        : warehouse.name,
      slug: warehouse.iwarehouse_slug,
      highways: warehouse.iwarehouse_highway
        ? warehouse.iwarehouse_highway.map((h) => h.highway_id)
        : null,
      highwayNames: warehouse.highways
        ? warehouse.highways.map((h) => h.highway_name).join(", ")
        : null,
    };
  }

  static fetchStock(stock) {
    return stock.map(SupplyInStock.fetch);
  }

  static fetchStockWarehouse(stock) {
    return stock.map(SupplyStockWarehouse.fetch);
  }

  static fetchSeparated(separated) {
    return separated.map(SeparatedSupply.fetch);
  }

  static send(warehouse) {
    return {
      iwarehouse_name: warehouse.name,
      highways: warehouse.highwayId,
    };
  }

  static modify(warehouse) {
    return {
      id: warehouse.id,
      iwarehouse_name: warehouse.name,
      highways: warehouse.highways,
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/warehouse.js